import { StoreSync } from "@/elements-react/product-area/store/sync";

export class NotFoundPageStore {
    sync = new StoreSync();
}